import PropTypes from 'prop-types';

export const PropTypeTopUpLimit = PropTypes.shape({
  piType: PropTypes.number,
  limit: PropTypes.shape({
    Max1stPaymentAmount: PropTypes.number,
    MinPaymentAmount: PropTypes.number,
  }),
});

export const PropTypeI18n = PropTypes.shape({
  getString: PropTypes.func,
  formatDecimal: PropTypes.func,
});

export const PropTypeSignupAddFundsResult = PropTypes.shape({
  submitting: PropTypes.bool,
  success: PropTypes.func,
  fail: PropTypes.func,
  cancel: PropTypes.func,
  CtpPiId: PropTypes.string,
  MtPiId: PropTypes.string,
});

export const PropTypesPaymentProps = PropTypes.shape({
  isPsd2ValidationEnabled: PropTypes.bool.isRequired,
  restfulService: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])).isRequired,
  culture: PropTypes.string.isRequired,
  ccBaseUrl: PropTypes.string.isRequired,
  pidlLoggerCreate: PropTypes.func,
});
